import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import StudentProgressChart from './StudentProgressChart'
import { Button, Tab, Tabs, Grid, DialogTitle, DialogContent, DialogActions, Dialog, Typography } from '@material-ui/core';

const styles = theme => ({

});

class StudentProgress extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <StudentProgressChart />
            </div>
        )
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

function mapStateToProps({ auth }) {
    return {

    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(StudentProgress)));


// WEBPACK FOOTER //
// src/main/content/progress/Progress.js